import React from "react";
/** @jsx jsx */
/* @ts-ignore */
import { jsx, css } from '@emotion/react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faPills } from "@fortawesome/free-solid-svg-icons";
import { Colors } from "../palettes/colorPalette";

type OpponentProps = {
	hp: number;
	maxHp: number;
	cells: number;
};

export const Opponent = (props: OpponentProps) => {
	const circumference = 52 * 2 * Math.PI;
	const [hp, setHp] = React.useState(props.hp);
	const [offset, setOffset] = React.useState(circumference);
	const [color, setColor] = React.useState("#36896E");
	const ref = React.useRef(hp);
	// #9C0412
	// #FFD700
	// #36896E

	React.useEffect(() => {
		ref.current = props.hp;
		setHp(ref.current);

		const percentHp = props.hp / props.maxHp * 100;
		let offset = circumference - percentHp / 100 * circumference;
		setOffset(offset);

		if (percentHp >= 90) {
			setColor("#36896E");
		} else if (percentHp >= 75) {
			setColor("#FFD700");
		} else if (percentHp <= 25) {
			setColor("#9C0412");
		}

	}, [props.hp]);

	React.useEffect(() => {
		const animation = document.getElementById("hp-circle");
		animation?.addEventListener('transitionend', () => {
		});
	}, []);

	return (
		<div css={css`
			border: none;
			padding-top: .5vh;
			padding-bottom: .8vh;
			display: flex;
			position: relative;
			text-align: center;
			justify-content:center;
			align-items:center;
		`}>
			<FontAwesomeIcon color={Colors.UIHighlight} icon={faHeart} />
			<span css={css`margin-left: .5em; margin-right:.5em`}>{hp}</span>
			<FontAwesomeIcon color={Colors.UITextAndBorders} icon={faPills} />
			<span css={css`margin-left: .5em; margin-right: .5em`}>{props.cells}</span>
		</div>
	);
};
